<template>
  <FormItem
    :prop="col.key"
    :label="isMethod(col.name, { formData, field: col, row: formData })"
    v-if="$hasPermission(col.id)"
    v-bind="col.formItemBind"
  >
    <template v-if="col.component === 'Select'">
      <Select
        :placeholder="handlePlaceholder(col, { formData, field: col })"
        :disabled="
          isMethod(col.disabled, { formData, field: col, row: formData })
        "
        v-model="formData[col.key]"
        @on-change="
          handleMethod({ methods: col.methods, name: 'on-change', field: col });
          clearFun(col.key);
        "
        @on-open-change="
          $event =>
            handleMethod({
              methods: col.methods,
              name: 'on-open-change',
              field: col,
              $event
            })
        "
        @on-select="handleMethod({ methods: col.methods, name: 'on-select' })"
        @on-clear="
          handleMethod({
            methods: col.methods,
            name: 'on-clear',
            field: col
          })
        "
        @on-create="handleSelectCreate"
        v-bind="col.bind"
        v-on="col.on"
        :filterable="col.filterable == undefined ? true : col.filterable"
        :filter-by-label="
          col.filterByLabel == undefined ? true : col.filterByLabel
        "
        :clearable="col.clearable == undefined ? true : col.clearable"
      >
        <Option
          v-for="item in col.options"
          :label="
            isMethodDefault(
              col.config && col.config.label,
              { formData, field: col, row: item },
              getProp(item, col.config, 'label')
            )
          "
          :value="getProp(item, col.config, 'value')"
          :key="
            isMethodDefault(
              col.config && col.config.value,
              { formData, field: col, row: item },
              getProp(item, col.config, 'key')
            )
          "
          @click.native="
            handleMethod({
              methods: col.methods,
              name: 'click',
              field: col,
              row: item
            })
          "
        ></Option>
      </Select>
    </template>
    <template v-else-if="col.component === 'Select2'">
      <Select
        :placeholder="handlePlaceholder(col, { formData, field: col })"
        :disabled="
          isMethod(col.disabled, { formData, field: col, row: formData })
        "
        v-model="formData[col.key]"
        @on-change="
          handleMethod({ methods: col.methods, name: 'on-change', field: col });
          clearFun(col.key);
        "
        @on-open-change="
          $event =>
            handleMethod({
              methods: col.methods,
              name: 'on-open-change',
              field: col,
              $event
            })
        "
        @on-select="handleMethod({ methods: col.methods, name: 'on-select' })"
        @on-clear="
          handleMethod({
            methods: col.methods,
            name: 'on-clear',
            field: col
          })
        "
        @on-create="handleSelectCreate"
        v-bind="col.bind"
        v-on="col.on"
        :filterable="col.filterable == undefined ? true : col.filterable"
        :filter-by-label="
          col.filterByLabel == undefined ? true : col.filterByLabel
        "
        :clearable="col.clearable == undefined ? true : col.clearable"
      >
        <Option
          v-for="item in col.options"
          :label="
            isMethodDefault(
              col.config && col.config.label,
              { formData, field: col, row: item },
              getProp(item, col.config, 'label')
            )
          "
          :value="getProp(item, col.config, 'value')"
          :key="
            isMethodDefault(
              col.config && col.config.value,
              { formData, field: col, row: item },
              getProp(item, col.config, 'key')
            )
          "
        ></Option>
      </Select>
    </template>

    <template v-else-if="col.component === 'SelectSearchable'">
      <Select
        :placeholder="handlePlaceholder(col, { formData, field: col })"
        :disabled="
          isMethod(col.disabled, { formData, field: col, row: formData })
        "
        v-model="formData[col.key]"
        @on-change="
          handleMethod({ methods: col.methods, name: 'on-change', field: col });
          clearFun(col.key);
        "
        @on-open-change="
          $event =>
            handleMethod({
              methods: col.methods,
              name: 'on-open-change',
              field: col,
              $event
            })
        "
        @on-select="handleMethod({ methods: col.methods, name: 'on-select' })"
        @on-clear="
          handleMethod({
            methods: col.methods,
            name: 'on-clear',
            field: col
          })
        "
        :remote-method="(query) => {
          handleMethod({
            methods: col.methods,
              name: 'remote-method',
              field: col,
              $event: query,
          })
        }"
        @on-create="handleSelectCreate"
        v-bind="col.bind"
        v-on="col.on"
        :filterable="col.filterable == undefined ? true : col.filterable"
        :filter-by-label="
          col.filterByLabel == undefined ? true : col.filterByLabel
        "
        :clearable="col.clearable == undefined ? true : col.clearable"
      >
        <Option
          v-for="item in col.options"
          :label="
            isMethodDefault(
              col.config && col.config.label,
              { formData, field: col, row: item },
              getProp(item, col.config, 'label')
            )
          "
          :value="getProp(item, col.config, 'value')"
          :key="
            isMethodDefault(
              col.config && col.config.value,
              { formData, field: col, row: item },
              getProp(item, col.config, 'key')
            )
          "
        ></Option>
      </Select>
    </template>

    <template v-else-if="col.component === 'Cascader'">
      <Cascader
        :placeholder="handlePlaceholder(col, { formData, field: col })"
        :disabled="
          isMethod(col.disabled, { formData, field: col, row: formData })
        "
        v-model="formData[col.key]"
        @on-change="
          handleMethod({ methods: col.methods, name: 'on-change', field: col })
        "
        v-bind="col.bind"
        v-on="col.on"
        :data="col.options"
        :load-data="
          (item, callback) =>
            handleMethod({
              methods: col.methods,
              name: col.fnName || 'loadData',
              row: formData,
              field: col,
              item,
              callback
            })
        "
      >
      </Cascader>
    </template>
    <template v-else-if="col.component === 'SelectTree'">
      <Select
        :placeholder="handlePlaceholder(col, { formData, field: col })"
        :disabled="
          isMethod(col.disabled, {
            formData,
            field: col,
            value: formData[col.key]
          })
        "
        :value="formData[col.key]"
        @on-select="handleMethod({ methods: col.methods, name: 'on-select' })"
        @on-change="
          handleMethod({ methods: col.methods, name: 'on-change', field: col });
          clearFun(col.key);
        "
        @on-clear="
          handleMethod({ methods: col.methods, name: 'on-clear', field: col })
        "
        v-bind="col.bind"
        v-on="col.on"
        :filterable="col.filterable == undefined ? true : col.filterable"
        :filter-by-label="
          col.filterByLabel == undefined ? true : col.filterByLabel
        "
        :clearable="col.clearable == undefined ? true : col.clearable"
      >
        <Option
          v-for="(item, index) in col.options"
          :label="
            isMethodDefault(
              col.config && col.config.label,
              { formData, field: col, row: item },
              getProp(item, col.config, 'label')
            )
          "
          :value="getProp(item, col.config, 'value')"
          :key="index"
          v-show="false"
        ></Option>
        <Tree
          :data="col.trees"
          @on-select-change="onTreeSelect"
          :select-node="true"
          :selected="true"
        ></Tree>
      </Select>
    </template>
    <!-- <template
      v-else-if="col.component === 'SelectTree1'"
      @on-select="handleMethod({ methods: col.methods, name: 'on-select' })"
    >
      <tree-select
        v-model="formData[col.key]"
        check-strictly
        v-bind="col.bind"
        :expand-all="true"
        :data="col.trees"
      ></tree-select>
    </template> -->
    <template v-else-if="col.component === 'Radio'">
      <RadioGroup
        v-model="formData[col.key]"
        v-bind="col.bind"
        @on-change="
          handleMethod({ methods: col.methods, name: 'on-change', field: col })
        "
      >
        <template v-for="item in col.options">
          <Radio
            v-if="$hasPermission(item.id)"
            :label="getProp(item, col.config, 'value')"
            :border="col.bind && col.bind.border"
            :key="getProp(item, col.config, 'value')"
            :disabled="
              isMethodDefault(
                col.disabled,
                { formData, field: col, row: formData, item },
                false
              ) ||
                isMethodDefault(
                  item.disabled,
                  { formData, field: col, row: item },
                  false
                )
            "
          >
            {{ getProp(item, col.config, "label") }}
          </Radio>
        </template>
      </RadioGroup>
    </template>
    <template v-else-if="col.component === 'Checkbox'">
      <CheckboxGroup
        v-model="formData[col.key]"
        v-bind="col.bind"
        @on-change="
          handleMethod({ methods: col.methods, name: 'on-change', field: col })
        "
      >
        <template v-for="item in col.options">
          <Checkbox
            v-if="$hasPermission(item.id)"
            :label="getProp(item, col.config, 'value')"
            :border="col.bind && col.bind.border"
            :key="getProp(item, col.config, 'value')"
            style="margin-bottom:5px"
            :disabled="
              isMethodDefault(
                item.disabled,
                { formData, field: col, row: item },
                false
              )
            "
          >
            {{ getProp(item, col.config, "label") }}
          </Checkbox>
        </template>
      </CheckboxGroup>
    </template>
    <template v-else-if="col.component === 'Upload'">
      <div
        v-if="
          isMethodDefault(
            col.bind && col.bind.preview,
            { formData, field: col },
            true
          )
        "
        :style="col.bind && col.bind.type !== 'drag' ? 'display:flex' : ''"
      >
        <Upload
          :multiple="col.bind && col.bind.multiple ? col.bind.multiple : true"
          :type="col.bind && col.bind.type ? col.bind.type : 'drag'"
          action="/"
          :accept="col.bind && col.bind.accept ? col.bind.accept : '*'"
          with-credentials
          :before-upload="
            file =>
              handleMethod({
                methods: col.methods,
                name: 'beforeUpload',
                file
              })
          "
        >
          <Button
            v-if="col.bind && (col.bind.isButton || col.bind.KH)"
            icon="ios-cloud-upload-outline"
            style="vertical-align: top"
            >{{ $t("updateFile") + $t("files") }}</Button
          >
          <div v-else style="padding: 20px 0">
            <Icon
              type="ios-cloud-upload"
              size="52"
              style="color: #3399ff"
            ></Icon>
            <p>{{ col.bind.content || $t("checkFile") }}</p>
          </div>
        </Upload>
        <KHGpy
          ref="KH"
          style="margin-left: 10px"
          v-if="col.bind.KH"
          button
          @confirm="
            ({ file }) =>
              handleMethod({
                methods: col.methods,
                name: 'KHConfirm',
                file
              })
          "
        />
        <div
          style="margin-left: 20px"
          v-if="
            col.bind &&
              col.bind.fileName &&
              formData[col.key] &&
              !col.bind.multiple &&
              col.bind.type !== 'drag'
          "
        >
          {{ $t("selDocument") }}:
          <span
            v-if="formData[col.key].preview"
            style="color: blue; cursor: pointer"
            @click="openSrc(formData[col.key].src)"
          >
            {{ formData[col.key].name }}
          </span>
          <span v-else>
            {{ formData[col.key].name }}
          </span>
        </div>
        <Button
          v-if="col.bind && col.bind.isButton && col.bind.tempUrl"
          style="margin-left: 20px"
          type="error"
          @click="tempDownload(col.bind.tempUrl)"
        >
          {{ $t("download_tem") }}
        </Button>
      </div>
      <div
        v-if="
          col.bind &&
            col.bind.fileName &&
            formData[col.key] &&
            Array.isArray(formData[col.key]) &&
            col.bind.multiple
        "
      >
        <!-- <template v-for="(item, index) in formData[col.key]">
          <div
            :key="item.lastModified ? item.lastModified : 'upload' + index"
            class="div-hover"
          >
            <span>{{ $t("selDocument") }}: {{ item.name }}</span>
            <Icon
              @click="
                col.methods['delUpload']
                  ? handleMethod({
                      methods: col.methods,
                      name: 'delUpload',
                      file: item
                    })
                  : delUploadFile(index, col.key)
              "
              class="icon-close"
              size="20"
              type="ios-close"
            />
          </div>
        </template> -->
        <template v-if="col.bind.previewFile">
          <div style="display: flex; flex-wrap: wrap; width: 100%">
            <div
              style="width: 50px; margin-right: 20px"
              v-for="(file, index) in formData[col.key]"
              :key="index"
            >
              <div class="file-item">
                <div
                  class="file-item-del"
                  v-if="
                    isMethodDefault(
                      col.deleteFile,
                      { formData, field: col },
                      true
                    )
                  "
                >
                  <Icon
                    size="18"
                    type="md-trash"
                    @click.native="
                      col.methods['delUpload']
                        ? handleMethod({
                            methods: col.methods,
                            name: 'delUpload',
                            file: file,
                            index: index,
                            key: col.key,
                            row: formData
                          })
                        : delUploadFile(index, col.key)
                    "
                  />
                  <Icon
                    size="18"
                    @click="
                      $form.isMethod(col.methods && col.methods.fileClick, {
                        field: col,
                        row: file
                      })
                    "
                    type="ios-eye"
                  />
                </div>
                <div
                  @click="
                    $form.isMethod(col.methods && col.methods.fileClick, {
                      field: col,
                      row: file
                    })
                  "
                  class="file-item-img"
                  :style="{
                    backgroundImage:
                      'url(' +
                      (isImage(file.src) ? $globalUrl + file.src : fileImage) +
                      ')'
                  }"
                ></div>
              </div>
              <div
                style="
                    text-align: center;
                    line-height: 14px;
                    word-break: break-all;
                  "
              >
                {{ file.name || file.filename }}
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <Tag
            type="border"
            @click.native="
              $form.isMethod(col.methods && col.methods.fileClick, {
                field: col,
                row: file
              })
            "
            v-for="(file, index) in formData[col.key]"
            :key="index"
            :closable="
              isMethodDefault(col.deleteFile, { formData, field: col }, true)
            "
            @on-close="
              col.methods['delUpload']
                ? handleMethod({
                    methods: col.methods,
                    name: 'delUpload',
                    file: file,
                    index: index,
                    key: col.key,
                    row: formData
                  })
                : delUploadFile(index, col.key)
            "
            >{{ file.name || file.filename }}</Tag
          >
        </template>
        <!-- <div
          v-for="(item, index) in formData[col.key]"
          class="div-hover"
          style="margin-top:10px;"
          :key="item.lastModified + index"
        >
          <span>{{ $t("selDocument") }}: {{ item.name }}</span>
          <Icon
            @click="delUploadFile(index, col.key)"
            class="icon-close"
            size="20"
            type="ios-close"
          />
        </div> -->
      </div>
    </template>
    <template v-else-if="col.component === 'Upload-img'">
      <div class="upload-flex">
        <template v-if="formData[col.key]">
          <div class="demo-upload-list">
            <img :src="formData[col.key]" />
            <div class="demo-upload-list-cover">
              <Icon
                type="ios-eye-outline"
                @click.native="handleView(formData[col.key])"
              >
              </Icon>
              <Upload
                ref="upload"
                accept="image/jpg, image/jpeg, image/png"
                :before-upload="
                  file =>
                    handleMethod({
                      methods: col.methods,
                      name: 'beforeUpload',
                      file
                    })
                "
                action=""
                :bind="col.bind"
              >
                <Button icon="ios-cloud-upload-outline">
                  {{ $t("updateFile") }}{{ $t("FrontIDCard") }}
                </Button>
              </Upload>
            </div>
          </div>
        </template>
        <Upload
          ref="upload"
          :show-upload-list="false"
          accept="image/jpg, image/jpeg, image/png"
          :before-upload="
            file =>
              handleMethod({
                methods: col.methods,
                name: 'beforeUpload',
                file
              })
          "
          action=""
          :bind="col.bind"
        >
          <Button style="width: 58px; height: 58px">
            <Icon type="ios-camera" size="20"></Icon>
          </Button>
        </Upload>
      </div>
    </template>
    <DatePicker
      v-else-if="col.component === 'DatePicker'"
      v-bind="col.bind"
      v-on="col.on"
      v-model="formData[col.key]"
      :disabled="
        isMethod(col.disabled, {
          formData,
          field: col,
          value: formData[col.key],
          row: formData
        })
      "
      :placeholder="handlePlaceholder(col, { formData, field: col })"
      :options="
        Object.assign(
          col.disabledDate ? {} : pickerOptions,
          (col.bind && col.bind.options) || {}
        )
      "
      :style="
        Object.assign({ width: '100%' }, (col.bind && col.bind.style) || {})
      "
      @on-change="
        handleMethod({ methods: col.methods, name: 'on-change', field: col });
        clearFun(col.key);
      "
      @on-ok="handleMethod({ methods: col.methods, name: 'on-ok' })"
      @on-open-change="openChange"
      @on-clear="
        handleMethod({ methods: col.methods, name: 'on-clear', field: col })
      "
    ></DatePicker>
    <AutoComplete
      v-else-if="col.component === 'AutoComplete'"
      v-model="formData[col.key]"
      :data="isMethod(col.data, { formData, field: col, row: formData })"
      @on-search="
        handleMethod({
          methods: col.methods,
          name: 'on-search',
          field: col
        })
      "
      @on-focus="
        handleMethod({
          methods: col.methods,
          name: 'on-focus',
          field: col
        })
      "
      :placeholder="handlePlaceholder(col, { formData, field: col })"
      v-bind="col.bind"
      v-on="col.on"
      :disabled="
        isMethod(col.disabled, { formData, field: col, row: formData })
      "
      :clearable="col.clearable == undefined ? true : col.clearable"
    >
    </AutoComplete>
    <template v-else-if="col.component">
      <Row align="middle" justify="space-between">
        <Col :span="col.bind && col.bind.col ? col.bind.col : 24">
          <component
            ref="formItem"
            :disabled="
              isMethod(col.disabled, {
                formData,
                field: col,
                value: formData[col.key],
                row: formData
              })
            "
            :placeholder="handlePlaceholder(col, { formData, field: col })"
            :is="isMethod(col.component)"
            v-bind="col.bind"
            v-on="col.on"
            v-model="formData[col.key]"
            :min="isMethod(col.bind && col.bind.min)"
            :max="isMethod(col.bind && col.bind.max)"
            :options="
              col.component === 'DatePicker'
                ? Object.assign(
                    col.disabledDate ? {} : pickerOptions,
                    col.bind && col.bind.options ? col.bind.options : {}
                  )
                : col.bind && col.bind.options
            "
            @click="
              handleMethod({
                methods: col.methods,
                name: 'click',
                field: col
              })
            "
            @on-enter="
              handleMethod({
                methods: col.methods,
                name: 'on-enter',
                field: col
              })
            "
            @on-change="
              handleMethod({
                methods: col.methods,
                name: 'on-change',
                field: col
              });
              clearFun(col.key);
            "
            @on-ok="handleMethod({ methods: col.methods, name: 'on-ok' })"
            @on-input="
              handleMethod({
                methods: col.methods,
                name: 'on-input',
                field: col
              })
            "
            @on-clear="
              handleMethod({
                methods: col.methods,
                name: 'on-clear',
                field: col
              })
            "
            @on-select="
              handleMethod({
                methods: col.methods,
                name: 'on-select',
                field: col
              })
            "
            @on-search="
              handleMethod({
                methods: col.methods,
                name: 'on-search',
                field: col
              })
            "
            @on-click="
              handleMethod({
                methods: col.methods,
                name: 'on-click',
                field: col
              })
            "
            @on-blur="
              handleMethod({
                methods: col.methods,
                name: 'on-blur',
                field: col
              })
            "
            @paste.native="paste"
            >{{
              handleMethod({ methods: col.methods, name: "render", field: col })
            }}
            <template v-if="col.bind && col.bind.prepend">
              <span slot="prepend">{{ col.bind.prepend }}</span>
            </template>
            <template v-if="col.bind && col.bind.append">
              <span slot="append">{{ col.bind.append }}</span>
            </template>
          </component>
        </Col>
        <Col :span="6" v-for="(item, index) in col.btnList" :key="index">
          <Button
            style="margin-left: 10px"
            @click="
              handleMethod({
                methods: item.methods,
                name: 'click',
                field: col
              })
            "
            v-bind="item.bind"
            :type="item.type"
            >{{ item.name }}</Button
          >
        </Col>
      </Row>
    </template>
    <ContentExpand
      v-else-if="col.render"
      :row="formData"
      :field="col"
      :render="col.render"
      v-bind="col.bind"
    >
    </ContentExpand>
    <slot
      v-else-if="col.solt"
      :name="col.solt"
      :field="col"
      :params="formData"
    ></slot>
    <template v-else>
      <div class="flex-center" v-bind="col.bind">
        {{ formData[col.key] }}
      </div>
    </template>
    <div v-if="col.remark" class="remark">{{ col.remark }}</div>
    <Modal
      v-if="imgView"
      :title="$t('show') + $t('bigImg')"
      :value="true"
      :transfer="false"
      footer-hide
      draggable
      @on-cancel="() => (imgView = '')"
    >
      <img :src="imgView" style="width: 100%" />
    </Modal>
  </FormItem>
</template>

<script>
import ContentExpand from "./expand";
import TreeSelect from "_c/tree-select";
import fileImage from "@/assets/images/file.png";
import KHGpy from "./KHGpy.vue";
export default {
  components: {
    ContentExpand,
    TreeSelect,
    KHGpy
  },
  inject: {
    $page: {
      default() {
        return this;
      }
    },
    $form: {
      default: () => null
    },
    $modal: {
      default: () => ({})
    }
  },
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    col: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Array,
      default: () => []
    }
  },
  beforeDestroy() {
    this.$refs["KH"] && this.$refs["KH"].cancel();
  },
  data() {
    return {
      fileImage,
      pickerOptions: {
        disabledDate(time) {
          return time && time.getTime() > Date.now();
        }
      },
      imgView: ""
    };
  },
  mounted() {
    //   let fieldKey = this.col.key.split(".");
    //   let fieldKeyLen = fieldKey.length - 1;
    //   let key = fieldKey.slice(0, fieldKeyLen).join(".");
    //   let field = this.col;
    //   if (key) {
    //     this.key = fieldKey[fieldKeyLen];
    //     this.value = this.$page.getObj(this.formData, key);
    //   } else {
    //     this.key = this.col.key;
    //     this.value = this.formData;
    //   }
    //   setTimeout(() => {
    //     this.tempValue = this.value[this.key];
    //   }, 100);
    this.col.ref = this.$refs.formItem;
    setTimeout(() => {
      if (this.col.bind && this.col.bind.focus) this.$refs.formItem.focus();
    }, 200);
  },
  methods: {
    openChange(val) {
      if (val) {
        this.handleMethod({
          methods: this.col.methods,
          name: "on-open",
          field: this.col
        });
      } else {
        this.handleMethod({
          methods: this.col.methods,
          name: "on-close",
          field: this.col
        });
      }
    },
    paste(e) {
      let text = (event.clipboardData || window.clipboardData).getData("text");
      if (this.col.paste && text) {
        this.formData[this.col.key] = "";
        setTimeout(() => {
          this.formData[this.col.key] = text;
        }, 0);
      }
    },
    handleSelectCreate(val) {
      this.col.options.push({
        value: val,
        label: val
      });
      this.handleMethod({
        methods: this.col.methods,
        name: "on-create",
        field: this.col,
        row: val
      });
      setTimeout(() => {
        if (!this.formData[this.col.key]) this.formData[this.col.key] = [val];
      }, 0);
    },
    openSrc(src) {
      if (src.includes("http")) {
        window.open(src, "_blank");
      } else {
        window.open((this.col.beforeUrl || this.$globalUrl) + src);
      }
    },
    isImage(src) {
      return /(.webp|.bmp|.jpg|.png|.tif|.gif)/.test(src);
    },
    // 删除图片
    delUploadFile(idx, key) {
      this.formData[key].splice(idx, 1);
      // console.log(idx, this.formData["files"]);
    },
    onTreeSelect(val) {
      document.body.click();
      this.formData[val[0].field.key] =
        val[0][
          val[0].field.config ? val[0].field.config.value || "value" : "value"
        ];
      if (this.$form)
        this.$form.handleTree({
          field: val[0].field,
          trees: val[0].field.trees
        });
    },
    handleView(url) {
      console.log(url.indexOf("data:image"));
      this.imgView =
        url.indexOf("http") != -1 || url.indexOf("data:image") != -1
          ? url
          : this.$globalUrl + url;
      // window.open(this.$globalUrl + url, "_blank");
    },
    handlePlaceholder(item, params) {
      let name = {
        Select: "select",
        DatePicker: "select"
      };
      return this.$page.isMethod(
        item.placeholder,
        params,
        (name[item.component] || "Please Enter ") + item.key
      );
    },
    isMethodDefault(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return df;
    },
    isMethod(methods, params, df) {
      if (typeof methods === "function") return methods.call(this, params);
      return df !== undefined ? df : methods;
    },
    getProp(item, config, name) {
      return item[config ? config[name] || name : name];
    },
    handleMethod({ methods, name, row, field, file, item, callback, $event }) {
      if (methods && methods[name])
        return methods[name].call(
          this,
          {
            row: this.formData,
            field: this.col,
            value: this.formData && this.formData[field && field.key],
            formData: this.formData,
            fields: this.fields,
            file,
            obj: row,
            item,
            callback
          },
          $event
        );
    },
    clearFun(key) {
      this.$emit("clearFun", key);
    },
    tempDownload(url) {
      window.open(url);
    },

    beforeUpload(file) {
      let formData = new FormData();
      formData.append("file", file); // 文件对象
      console.log(formData, file);
      return false;
    },
    readFile(file) {
      let _this = this;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onloadstart = e => {
        this.uploadLoading = true;
        this.tableLoading = true;
        this.showProgress = true;
      };
      reader.onprogress = e => {
        this.progressPercent = Math.round((e.loaded / e.total) * 100);
      };
      reader.onerror = e => {
        this.$Message.error("文件读取出错");
      };
      reader.onload = e => {
        const data = e.target.result;
        const { header, results } = excel.read(data, "array");
        //const tableTitle = header.map(item => { return { title: item, key: item } })
        // 以下为处理数据
        results.splice(0, 1);
        if (results.length == 0) {
          this.$Message["error"]({
            background: true,
            content: "数据不能为空",
            duration: 5
          });
          return;
        }
        this.upxls({ orderData: results, type: this.type });
      };
    }
  }
};
</script>

<style lang="less">
.ivu-auto-complete {
  .ivu-select-dropdown {
    max-height: 220px !important;
  }
}

.div-hover {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.div-hover:hover {
  background-color: #eee;

  .icon-close {
    display: block;
  }
}

.icon-close {
  display: none;
}

.remark {
  color: #0000ff;
  line-height: 16px;
  margin-top: 3px;
  font-size: 12px;
}

.ivu-radio-disabled .ivu-radio-inner:after {
  background-color: red;
}

.file-item {
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  width: 50px;
  height: 50px;
  display: inline-block;

  .file-item-del {
    color: white;
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    text-align: center;
    line-height: 50px;
    display: none;
  }

  .file-item-img {
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: 50% 50%;
  }

  &:hover {
    .file-item-del {
      display: block;
    }
  }
}
</style>
